import { createSlice } from "@reduxjs/toolkit";

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    documentsSubmitted: false,
    addBankModal: false,
    addUpiModal: false,
  },
  reducers: {
    submitDocument: (state) => {
      state.documentsSubmitted = true;
    },
    setDocumentsSubmittedFalse: (state) => {
      state.documentsSubmitted = false;
    },
    showAddBankModal: (state) => {
      state.addBankModal = true;
    },
    closeAddBankModal: (state) => {
      state.addBankModal = false;
    },
    showAddUpiModal: (state) => {
      state.addUpiModal = true;
    },
    closeAddUpiModal: (state) => {
      state.addUpiModal = false;
    },
  },
});

export const {
  submitDocument,
  closePopup,
  setDocumentsSubmittedFalse,
  showAddBankModal,
  closeAddBankModal,
  showAddUpiModal,
  closeAddUpiModal,
} = profileSlice.actions;

export default profileSlice.reducer;
